import TrashIcon from './TrashIcon';

export default TrashIcon;
